/**
 * Client Entry Point
 *
 * Hydrates the server-rendered React app on the client side.
 */

import { StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Providers } from './providers';
import { App } from './App';
import './index.css';

// Register service worker for caching
if ('serviceWorker' in navigator && typeof window !== 'undefined') {
  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js', {
        updateViaCache: 'none',
      });

      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              console.log('New version available! Refreshing...');
              newWorker.postMessage('skipWaiting');
            }
          });
        }
      });

      let refreshing = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (!refreshing) {
          refreshing = true;
          window.location.reload();
        }
      });
    } catch (err) {
      console.log('Service worker registration failed:', err);
    }
  });
}

hydrateRoot(
  document.getElementById('root')!,
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <Providers>
          <App />
        </Providers>
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>,
  {
    onRecoverableError: (error, errorInfo) => {
      console.error('Hydration error:', error);
      console.error('Error info:', errorInfo);
      if (errorInfo.componentStack) {
        console.error('Component stack:', errorInfo.componentStack);
      }
    },
  }
);
